export default __webpack_public_path__ + "static/media/news-3.d3afc696.jpg";